export default __webpack_public_path__ + "static/media/email_credential.9ae77fe3.png";